<script>
export let free_agent;


import FreeAgentModal from 'components/views/my/free-agents/elements/FreeAgentModal.svelte';



let name;
let position;
let birth_year;
let current_team_level;
let city;
let province;


$: {

	name = free_agent.player_first_name + ' ' + free_agent.player_last_name;

	position = free_agent.position;

	birth_year = String(free_agent.player_date_of_birth).substring(0,4);

	current_team_level = free_agent.current_team_level;

	city = free_agent.city;

	province = free_agent.province;

	// more info

}


let is_active = false;

</script>



<style>

.free-agent-thumb {
	transition: all ease 0.15s;
}

.free-agent-thumb:hover {
	background: #fafafb;
	cursor: pointer;
}

</style>



<FreeAgentModal {free_agent} bind:is_active />



<div class="panel-block free-agent-thumb" on:click={() => {is_active = true}}>

	<div class="columns is-variable is-mobile is-2 is-vcentered">

		<div class="column is-3-desktop is-4-touch">
			<span>
				{name}
			</span>
		</div>

		<div class="column is-2-desktop is-3-touch" style="text-transform: capitalize;">
			<span>
				{position}
			</span>
		</div>

		<div class="column is-1-desktop is-2-touch">
			<span>
				{birth_year}
			</span>
		</div>

		<div class="column is-2-desktop is-3-touch">
			<span>
				{current_team_level}
			</span>
		</div>

		<div class="column is-2-desktop is-hidden-touch">
			<span>
				{city}
			</span>
		</div>


		<div class="column is-2-desktop is-hidden-touch">
			<span>
				{province}
			</span>
		</div>

	</div>

</div>



